
import Vue from "vue";
import {RoadmapItem} from "@/models/roadmap-item";
import AppSelectApp from "@/components/SelectApp.vue";
import { App, getAppSelectItems } from "@/utils/apps";
import { IDataTableColumn, ISelectItem } from "winfakt-vue-components";
import { RoadmapService } from "@/services/roadmap-service";
import { Admin } from "@/models/admin";

export default Vue.extend({
	data(){
		return {
			app: App.WINFAKT_MAIN_APP,
			selectedItems: [] as RoadmapItem[],
			items: [] as RoadmapItem[],
			orderColumn: "id",
			orderDirection: false
		};
	},
	computed: {
		apps():ISelectItem<App>[]{
			return getAppSelectItems().filter(f=>f.value != App.WINFAKT_ONLINE_AUTH);
		},
		editDisabled():boolean{
			return this.selectedItems.length != 1;
		},
		deleteDisabled():boolean {
			return this.selectedItems.length == 0;
		},
		editLink():string{
			if (this.selectedItems.length != 1) return "";
			return `/roadmap/edit/${this.selectedItems[0].id}`;
		},
		priorityEditLink():string{
			return `/roadmap/priorities/${this.app}`;
		},
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "id",
					width: "80px"
				},
				{
					name: "Title",
					property: "title",
					width: "200px"
				},
				{
					name: "Status",
					property: "status",
					width: "120px"
				},
				{
					name: "Date",
					property: "date",
					width: "140px",
					print(value:Date | null):string{
						if (value == null) return "NULL";
						return `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`;
					}
				},
				{
					name: "Owner",
					property: "admin",
					width: "120px",
					print(value:Admin):string{
						return value.name;
					}
				}
			];
		}
	},
	methods: {
		async onAppInput(app:App){
			if (app == this.app) return;
			this.app = app;
			this.items = [];
			this.selectedItems = [];
			this.items = await RoadmapService.getItemsByAppName(this.app);
		},
		edit(item:RoadmapItem){
			this.$router.push(`/roadmap/edit/${item.id}`);
		}
	},
	async mounted(){
		this.items = await RoadmapService.getItemsByAppName(this.app);
	},
	components: {
		AppSelectApp
	}
});
